import { Trans, useTranslation } from 'react-i18next';
import { useOfferBuilderContext } from '@/enterprise/components/OfferBuilder/OfferBuilderContext';
import QueryBoundaries from '@/shared/components/QueryBoundaries';
import SrmDetailsCard from '@/shared/components/SrmDetailsCard';

const standardListKeys = [
  'builder.aboutThisOffer.description',
  'builder.aboutThisOffer.description2',
  'builder.aboutThisOffer.description3',
  'builder.aboutThisOffer.description4',
];

const acquisitionListKeys = [
  'builder.aboutThisOffer.acquisition.description1',
  'builder.aboutThisOffer.acquisition.description2',
  'builder.aboutThisOffer.acquisition.description3',
  'builder.aboutThisOffer.acquisition.description4',
];

const AboutThisOffer = () => {
  const { t } = useTranslation();
  const {
    state: { builderVariant },
  } = useOfferBuilderContext();

  const isAcquisition = builderVariant === 'acquisition';
  const title = isAcquisition ? t('builder.aboutThisOffer.acquisition.title') : t('builder.aboutThisOffer.title');
  const listKeys = isAcquisition ? acquisitionListKeys : standardListKeys;

  return (
    <>
      <div className="space-y-2">
        <div className="font-bold">{title}</div>
        <div>
          <ul className="ml-4 list-disc text-sm">
            {listKeys.map((key) => (
              <li key={key}>
                <Trans i18nKey={key} components={{ bold: <span className="font-medium" /> }} />
              </li>
            ))}
          </ul>
        </div>
      </div>
      <QueryBoundaries>
        <div className="space-y-2 pt-6">
          <div className="font-bold">{t('builder.haveQuestions')}</div>
          <div>
            <SrmDetailsCard withDescription={false} />
          </div>
        </div>
      </QueryBoundaries>
    </>
  );
};

export default AboutThisOffer;
